import ApiConstants from '../../constants/ApiConstants';
import queryString from 'query-string';
import xhr from './xhr';

const LessonApiUtils = {
  fetchMyLessons(page, status_ids, other_user_id) {
    const query = queryString.stringify({
      page,
      other_user_id,
      'status_ids[]': status_ids,
    });
    return xhr(`${ApiConstants.Base}lessons/mine?${query}`);
  },
  fetchStudentLessons(studentId, page, tutorId) {
    const query = `?page=${page}&tutor_id=${tutorId}`;
    return xhr(`${ApiConstants.FetchStudentLessons}/${studentId}${query}`);
  },
  fetchTutorLessons(tutorId, page, studentId) {
    const query = `?page=${page}&student_id=${studentId}`;
    return xhr(`${ApiConstants.FetchTutorLessons}/${tutorId}${query}`);
  },

  fetchTutorLessonsWithOpenIssue(page) {
    const query = `?page=${page}`;
    return xhr(`${ApiConstants.FetchTutorLessonsWithOpenIssue}${query}`);
  },

  fetchStudentLessonsWithOpenIssue(page) {
    const query = `?page=${page}`;
    return xhr(`${ApiConstants.FetchStudentLessonsWithOpenIssue}${query}`);
  },

  fetchLessonSize(studentId) {
    return xhr(`${ApiConstants.FetchLessonSize}/${studentId}`);
  },

  fetchOne(id) {
    return xhr(`${ApiConstants.FetchLessonById}/${id}`);
  },

  markAsSkipped(lessonId) {
    return xhr(`${ApiConstants.MarkAsSkipped}/${lessonId}`, {
      method: 'put',
    });
  },

  markAsSkippedByTutor(lessonId) {
    return xhr(`${ApiConstants.MarkAsSkippedByTutor}/${lessonId}`, {
      method: 'put',
    });
  },
  getMyLessonSize(id) {
    return xhr(`${ApiConstants.Base}lesson-size/${id}`);
  },
};

export default LessonApiUtils;
